var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRebooting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_rebooting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Single-page-4--1-icons",
    transform: "translate(-979.000000, -539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_rebooting",
    transform: "translate(979.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5697B7",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px",
    transform: "translate(18.000000, 17.000000) rotate(-43.000000) translate(-18.000000, -17.000000) translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1 L7,6 L12,11 L12,7 C15.31,7 18,9.69 18,13 C18,16.31 15.31,19 12,19 C8.69,19 6,16.31 6,13 L4,13 C4,17.42 7.58,21 12,21 C16.42,21 20,17.42 20,13 C20,8.58 16.42,5 12,5 L12,1 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5697B7",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-24px",
    transform: "translate(18.000000, 17.000000) rotate(-43.000000) translate(-18.000000, -17.000000) translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1 L7,6 L12,11 L12,7 C15.31,7 18,9.69 18,13 C18,16.31 15.31,19 12,19 C8.69,19 6,16.31 6,13 L4,13 C4,17.42 7.58,21 12,21 C16.42,21 20,17.42 20,13 C20,8.58 16.42,5 12,5 L12,1 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRebooting);
export default __webpack_public_path__ + "static/media/icon_rebooting.a262cd58e9b8134ea85982705e2a635d.svg";
export { ForwardRef as ReactComponent };